import type { RadioGroupItemProps } from "./types-item";
import { useRadioGroupItem } from "./use-item";
import { RadioGroupItemView } from "./view-item";

export function RadioGroupItem(props: RadioGroupItemProps) {
  const viewModel = useRadioGroupItem(props);

  return <RadioGroupItemView {...viewModel} />;
}
RadioGroupItem.displayName = "RadioGroup.Item";
